// extracted by mini-css-extract-plugin
module.exports = {"root":"GaDropdown-module__root__1TyG6","dropdown-width":"GaDropdown-module__dropdown-width__3nG7A"};